import { render } from "./CardMetaList.vue.js?vue&type=template&id=24f94bb5!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CardMetaList.vue?vue&type=template&id=24f94bb5"
const script = {}

import "./CardMetaList.vue.scss?vue&type=style&index=0&id=24f94bb5&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CardMetaList.vue?vue&type=style&index=0&id=24f94bb5&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__